import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IRfqLot } from '../rfq/interfaces/rfq-lot.interface';

import { ILocationOld, ILocationState } from './interfaces/location.interface';

@Injectable({
  providedIn: 'root',
})
export class LocationStateService {
  private initialState :ILocationState = {
    locations: [],
    loading: false,
    currentLocation: null,
    currentQueryParams: {
      per_page: '20',
      parent_id: '0',
      page: '1',
      keyword: '',
    },
    lots: [],
  };

  private _state$ = new BehaviorSubject<ILocationState>(this.initialState);

  // Observable stream for components to subscribe to

  constructor() {}

  // Method to update the state
  updateState(newState :Partial<ILocationState>) :void {
    // Update the state with new state
    this._state$.next({ ...this._state$.getValue(), ...newState });
  }

  get state$() {
    return this._state$.asObservable();
  }

  get state() :ILocationState {
    return this._state$.getValue();
  }

  // Accessors for state properties
  get locations$() :Observable<ILocationOld[]> {
    return this.state$.pipe(map((state) => state.locations));
  }

  get lots$() :Observable<IRfqLot[]> {
    return this.state$.pipe(map((state) => state.lots));
  }

  get loading$() :Observable<boolean> {
    return this.state$.pipe(map((state) => state.loading));
  }

  get currentQueryParams() :{ [param :string] :string | string[] } {
    return this.state.currentQueryParams;
  }
}
